module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Sending mail-cd92fc16a2bc741240aebc4a9cbbca34.svg";